import { envIsProduction, envIsTest } from 'dg-web-shared/lib/Environment.ts';

function assembleDevUrl(appUrlTag: string) {
    const match = window.location.host.match(
        /operator\.(.*)\.digitalparking\.(dev|ch)/,
    );
    if (match && match.length === 3) {
        return `https://${appUrlTag}.${match[1]}.digitalparking.${match[2]}`;
    }

    // fallback
    return `https://${appUrlTag}.test.digitalparking.ch`;
}

export const parkingaboUrl = () => {
    const devUrl = assembleDevUrl('parkingabo');

    if (envIsProduction()) {
        return 'https://parkingabo.ch';
    }
    if (envIsTest()) {
        return 'https://parkingabo.test.digitalparking.ch';
    }
    return devUrl;
};

export const enforcementUrl = () => {
    const devUrl = assembleDevUrl('enforcement');

    if (envIsProduction()) {
        return 'https://check.digitalparking.ch';
    }
    if (envIsTest()) {
        return 'https://enforcement.test.digitalparking.ch';
    }
    return devUrl;
};
